import * as React from "react";

import { CalendarAppointments } from "@/components/layouts/sidebar-right/calendar-appointments";
import { TeamSwitcher } from "@/components/layouts/sidebar-right/team-switcher";

import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar";

export function SidebarRight({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="none" className="sticky hidden lg:flex top-0 h-svh border-l" {...props}>
      <SidebarHeader className="h-16 border-b border-sidebar-border flex item-center justify-center">
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent className="p-0">
        <CalendarAppointments />
      </SidebarContent>
      <SidebarFooter></SidebarFooter>
    </Sidebar>
  );
}

